import { createRouter, createWebHashHistory } from "vue-router";
import BoardView from "../views/BoardView.vue";
import AuthView from "../views/AuthView.vue";
// import LandingPage from "../views/LandingView.vue";

import store from "../store";

import { Auth } from "@/service/auth/authService";

const AuthInitPromise = Auth.authStatePromise();

const routes = [
  // {
  //   path: "/",
  //   name: "BoardHome",
  //   component: LandingPage,
  // },
  {
    path: "/",
    name: "BoardView",
    component: BoardView,
    // children: [{ path: "task", name: "task", component: SingleTaskView }],
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: "/auth/:action",
    name: "AuthView",
    component: AuthView,
  
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to) => {
  await AuthInitPromise;
  const isAuthenticated = store.state.auth.userLoggedIn;
  if (!isAuthenticated && to?.meta?.requiresAuth) {
    return '/auth/login'
  }
})

export default router;
